export const getValidationFields = (fields) => {
  if (!fields?.length) return {};
  return fields.reduce((acc, next) => {
    acc[next] = false
    return acc;

  }, {});
}